import { SalesOrderStatus } from '../constants/sales-order-status.js';
/** Statuses with no live submitted order to pay against (terminal, or not yet submitted), shared by every payment write. */
export const BLOCKED_PAYMENT_STATUSES = [
    SalesOrderStatus.DRAFT,
    SalesOrderStatus.AWAITING_APPROVAL,
    SalesOrderStatus.CANCELLED,
    SalesOrderStatus.REJECTED,
];
//# sourceMappingURL=blocked-payment-statuses.js.map